'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/app/components/HeroSection';
import LabelTransparencySection from '@/app/components/LabelTransparencySection';
import ProductsSection from '@/app/components/ProductsSection';
import BrandStorySection, { BrandVideoSection } from '@/app/components/BrandStorySection';
import ScrollRevealInit from '@/app/components/ScrollRevealInit';
import TestimonialsSection from '@/app/components/TestimonialsSection';
import { useFloodlightPageview } from '@/lib/useFloodlightPageview';
import { FLOODLIGHT_ACTIVITIES } from '@/lib/floodlight';

export default function HomeClient() {
  useFloodlightPageview(FLOODLIGHT_ACTIVITIES.homePage);

  return (
    <main className="grain-overlay bg-background min-h-screen overflow-x-hidden">
      <Header />
      <HeroSection />
      <BrandStorySection />
      <ProductsSection />
      <BrandVideoSection />
      <LabelTransparencySection />
      <TestimonialsSection />
      <Footer />
      <ScrollRevealInit />
    </main>
  );
}
